import { Grid } from "@mui/material";

import FormikInput from "../../components/Form/FormikInput";
import Form from "../../components/Templates/Form";
import useLocationContainer from "../../containers/Locations/useLocationContainer";
import FormikMap from "../../components/Map";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import { useParams } from "react-router-dom";

const EditEvent = () => {
  const { gameId, locationId } = useParams();

  const {
    pageLoading,
    formik,
    loading,
    center,
    handleMarker,
    handleSearch,
    setCenter,
    zoom,
    setZoom,
  } = useLocationContainer(gameId, locationId);

  const { general, pages } = useContent();
  const { locations } = pages;
  const { isRTL } = useRTL();

  return (
    <Form
      title={locations.location}
      pageLoading={pageLoading}
      formik={formik}
      submitLoading={loading}
      width="75%"
      id={locationId}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormikMap
            center={center}
            setCenter={setCenter}
            markers={[
              {
                pos: {
                  lat: formik.values.latitude,
                  lng: formik.values.longitude,
                },
              },
            ]}
            handleMarker={(e: any) => handleMarker(e)}
            handleSearch={handleSearch}
            zoom={zoom}
            setZoom={setZoom}
            sx={{ height: "400px" }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikInput
            formik={formik}
            type="number"
            name="latitude"
            label={locations.lat}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormikInput
            formik={formik}
            type="number"
            name="longitude"
            label={locations.lng}
          />
        </Grid>
      </Grid>
    </Form>
  );
};

export default EditEvent;
